import React, { useEffect, useState } from "react";
import Header from "components/user/Header";
import banner from "assets/img/banner.png";
import CardProfileSekolah from "components/user/profile/profile-sekolah/CardProfileSekolah";
import Footer from "components/user/Footer";
import BeritaPopuler from "components/user/BeritaPopuler";
import axios from "axios";

function ProfileSekolah() {
  const [bannerImage, setBannerImage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await axios.get(
          "/api_w/header?title=profile sekolah",
          {
            headers: {
              db_name: process.env.REACT_APP_DB_NAME,
            },
          }
        );
        const imageUrl = response.data.data.image_url;

        // Preload the image
        const img = new Image();
        img.src = imageUrl;

        // Set the banner image
        setBannerImage(imageUrl);
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBanner();
  }, []);

  return (
    <>
      <Header />
      <div className="relative top-[35px] mt-[30px] inline-flex h-auto w-full">
       
      </div>
      <div className="row mt-10 flex flex-wrap gap-6 p-5">
        <div className="w-full lg:w-[68%]">
          <CardProfileSekolah />
        </div>
        <div className="w-full lg:ml-auto lg:w-[30%]">
          <BeritaPopuler />
        </div>
      </div>
      <Footer />
    </>
  );
}
export default ProfileSekolah;
